import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { testIds } from '../../../../core/testIds';

import styles from './DepositTab.module.css';

const DepositTab: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <p className={styles.message} data-testid={testIds.settings.depositMessage}>
        {t('deposit_message', {
          defaultValue: 'Your balance may take a moment to update after a successful deposit.',
        })}
      </p>
    </div>
  );
};

export default DepositTab;
